import { useEffect } from "react";
import { snackbarService } from "../../services/snackbarService";
export default ({ condition, message, }) => {
    useEffect(() => {
        if (condition && message) {
            snackbarService.show({
                variant: "error",
                message,
            });
        }
    }, [condition]);
};
//# sourceMappingURL=useValidationErrorSnackbar.js.map